// extracted by mini-css-extract-plugin
module.exports = {"container":"entity-notice-terminal_container__0Z9E5","subtitle":"entity-notice-terminal_subtitle__cYcqk"};